// extracted by mini-css-extract-plugin
module.exports = {"big-mesh-b-root":"BigMeshB_big-mesh-b-root__2xFed"};